import React, { useState, createContext, useEffect, useContext} from "react"
import detectBrowserLanguage from 'detect-browser-language'

import drapeauFR from '../images/drapeau_FR.svg';
import drapeauEN from '../images/drapeau_EN.svg';

export const LanguageContext = createContext()

const allLanguages = [
  {"id" : "fr", "flag" : drapeauFR },
  {"id" : "en", "flag" : drapeauEN },
]

/* ⛔ 01/10/2026 — EXPORTE POUR LE BANC, ET POUR UNE RAISON PRECISE.
   Le filet remplacait TOUT le dictionnaire par une chaine unique : « Valider ».
   Tous ses ecrans portaient donc des libelles de 7 caracteres, alors que les
   vrais vont jusqu'a « Retour au dashboard » (19). Resultat : aucun defaut lie
   a la LONGUEUR d'un libelle ne pouvait apparaitre au banc — et c'est
   exactement le point 6 de la fiche d'Hicham du 01/10.
   Rien d'autre ne change : `values` reste la meme donnee, au meme endroit. */
export const values = {
  passwordValidation:{
    required : {
      "fr" : "Veuillez entrer un mot de passe",
      "en" : "Please enter a password"
    },
    match1 : {
      "fr" : "Doit contenir au moins 8 caractères, 1 majuscule, 1 minuscule, 1 chiffre et un caractère spécial",
      "en" : "Must contain at least 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
    },
    match2 : {
      "fr" : "Doit contenir au moins 1 majuscule et 1 minuscule",
      "en" : "Must contain at least 1 uppercase letter and 1 lowercase letter"
    },
    match3 : {
      "fr" : "Doit contenir au moins 1 chiffre et un caractère spécial (les symboles + et = ne sont pas valides)",
      "en" : "Must contain at least one digit and one special character (the symbols + and = are not valid)"
    },
    min : {
      "fr" : "Doit contenir au moins 8 caractères",
      "en" : "Must contain at least 8 characters"
    },
    confirmSame : {
      "fr" : "Les mots de passe doivent correspondre",
      "en" : "Passwords must match"
    }
  },
  authError : {
    "fr" : "Vous avez été déconnecté, redirection dans 10 secondes",
    "fr_tu" : "Tu as été déconnecté, redirection dans 10 secondes",
    "en" : "You have been disconnected, redirecting in 10 seconds",
  },
  error : {
    "fr" : "Erreur",
    "en" : "Error"
  },
  notifSaveModif : {
    "fr" : "Modifications enregistrées\u00a0!",
    "en" : "Saved changes!"
  },
  // E6 review 02/09 : confirmation apres un export (PDF ou tableau)
  notifExport : {
    "fr" : "Export réussi\u00a0!",
    "en" : "Export successful!"
  },
  notifError : {
    "fr" : "Une erreur est survenue\u00a0!",
    "en" : "An error has occurred!"
  },
  /* 06/10/2026 : remplace les `alert("Error")` en anglais vus par l'apprenant
     (inscription, premiere connexion) */
  erreurReessayer : {
    "fr" : "Une erreur est survenue. Merci de réessayer.",
    "en" : "An error occurred. Please try again.",
  },
  areYouSure : {
    "fr" : "Êtes-vous sûr\u00a0?",
    "fr_tu" : "Es-tu sûr\u00a0?",
    "en" : "Are you sure?"
  },
  language : {
    "fr" : "Français",
    "en" : "English",
  },
  page404 : {
    "fr" : "La page que vous recherchez ne se trouve pas ici",
    "en" : "The page you are looking for isn’t here",
  },
  requiredField : {
    "fr" : "Champ requis",
    "en" : "Required field",
  },
  search : {
    "fr" : "Chercher ...",
    "en" : "Search ...",
  },
  close : {
    "fr" : "Fermer",
    "en" : "Close",
  },
  save : {
    "fr" : "Enregistrer",
    "en" : "Save",
  },
  continue : {
    "fr" : "Continuer",
    "en" : "Continue",
  },
  validate : {
    "fr" : "Valider",
    "en" : "Validate",
  },
  /* ⛔ POURQUOI « Valider » RESTE GRISE (demande d'Hicham, 22/09/2026).
     Le bouton est desactive tant que la reponse fait moins de 4 caracteres, et
     RIEN ne le disait : l'apprenant voyait un bouton mort sans savoir pourquoi.
     Le nombre est injecte par le format depuis sa constante, il n'est pas ecrit
     en dur ici : le texte et la regle ne peuvent donc pas diverger. */
  reponseMinimum : {
    "fr" : "Merci d\u2019écrire au moins une phrase pour pouvoir valider",
    "en" : "Please write at least one sentence to validate",
  },
  /* ⛔ POINT 1.3 DE LA FICHE V2 — LA REGLE DES LIBELLES DE BOUTON.
     Nawal : « Valider » quand le clic enregistre une reponse, « Continuer »
     quand il affiche la correction ou la suite d'un meme ecran, « Suivant »
     quand il passe a l'ecran suivant sans rien enregistrer.
     Elle ECRASE les libelles saisis dans les contenus : se contenter de
     remplir les champs vides aurait laisse « C'est parti ! » et « On
     continue ? » dans les anciens modules indefiniment. Le champ de saisie
     libre est retire des cinq formats concernes, faute de quoi les libelles
     rederiveraient dans six mois. */
  next : {
    "fr" : "Suivant",
    "en" : "Next",
  },
  modalMustLandscape : {
    title : {
      "fr" : "Orientation",
      "en" : "Orientation",
    },
    text : {
      "fr" : "Pour une meilleure expérience, nous vous conseillons d'utiliser votre appareil en mode paysage",
      "fr_tu" : "Pour une meilleure expérience, nous te conseillons d'utiliser ton appareil en mode paysage",
      "en" : "For a better experience, we advise you to use your device in landscape mode",
    }
  },
  modalMustPortrait : {
    title : {
      "fr" : "Orientation",
      "en" : "Orientation",
    },
    text : {
      "fr" : "Pour une meilleure expérience, nous vous conseillons d'utiliser votre appareil en mode portrait",
      "fr_tu" : "Pour une meilleure expérience, nous te conseillons d'utiliser ton appareil en mode portrait",
      "en" : "For a better experience, we advise you to use your device in portrait mode",
    }
  },
  formation : {
    // Ecart 8 : legende sous le R qui se compose pendant le calcul du score
    analyseEnCours : {
      "fr" : "Analyse de vos réponses…",
      "fr_tu" : "Analyse de tes réponses…",
      "en" : "Analyzing your answers…",
    },
    /* PD-10 (25/09/2026, decision d'Hicham) : un candidat THE SCAN ne voit
       AUCUNE statistique de ses resultats. A la place du bilan du Diagnostic,
       cet ecran neutre, qui laisse continuer. Il n'affirme PAS que les
       reponses sont enregistrees : l'envoi du Diagnostic ne part qu'au clic
       sur « Suivant », et un enregistrement precedent a pu echouer.
       ⚠️ Texte PROVISOIRE, a faire valider par Nawal. */
    merciPourVosReponses : {
      "fr" : "Merci pour vos réponses. Vous pouvez continuer.",
      "fr_tu" : "Merci pour tes réponses. Tu peux continuer.",
      "en" : "Thank you for your answers. You can continue.",
    },
    // L63 : titres du bloc d'explication affiche apres validation d'un quiz
    bonneReponse : {
      "fr" : "Bonne réponse",
      "en" : "Correct answer",
    },
    mauvaiseReponse : {
      "fr" : "Mauvaise réponse",
      "en" : "Wrong answer",
    },
    /* 27/09/2026, chantier « scores cote serveur » : la reponse d'un candidat
       THE SCAN part au serveur, qui rend la correction. Si l'envoi echoue,
       l'ecran reste non repondu et le dit, ici. Le texte francais est celui
       qu'affichait deja l'echec d'un enregistrement (UserContext), pour ne pas
       inventer une seconde formulation du meme probleme. */
    reponseNonEnregistree : {
      "fr" : "Votre réponse n'a pas pu être enregistrée. Vérifiez votre connexion puis réessayez.",
      "fr_tu" : "Ta réponse n'a pas pu être enregistrée. Vérifie ta connexion puis réessaie.",
      "en" : "Your answer could not be saved. Check your connection and try again.",
    },
    /* 04/10/2026 : « Seuil de certification », le libelle de la planche 15
       (4:854, 4:1127, 4:1339). « Seuil » seul ne disait pas de quoi. */
    seuil : {
      "fr" : "Seuil de certification",
      "en" : "Certification threshold",
    },
    pending : {
      "fr" : "En attente",
      "en" : "Pending",
    },
    yourAnswer : {
      "fr" : "Votre réponse",
      "fr_tu" : "Ta réponse",
      "en" : "Your answer",
    },
    pageTitle : {
      "fr" : "Formation",
      "en" : "Training",
    },
    /* Libelle de la carte de score du Diagnostic, node Figma 4:1454.
       ⚠️ Il remplace `votrePositionnement`, appelee par FormatDiag mais JAMAIS
       DEFINIE ici : la carte n'affichait donc que le pourcentage, sans dire de
       quoi il etait le pourcentage. Le mot est celui de la planche. */
    scoreGlobal : {
      "fr" : "Score global",
      "en" : "Overall score",
    },
    /* TITRE FIXE DU DIAGNOSTIC — planche 14. La planche porte un titre COURT
       et constant au-dessus du texte de restitution, puis le feedback de
       l'apprenant EN CORPS DE TEXTE. Le produit n'avait pas ce titre : le
       feedback occupait le slot de titre, rendu a 42 px, d'ou le pave qui
       poussait la carte de score et la liste de competences vers le bas.
       ⚠️ Le francais est le mot exact de la planche finale. L'anglais est une
       traduction directe : si Nawal veut une autre formule, c'est ici. */
    votrePositionnement : {
      "fr" : "Voici comment vous vous positionnez aujourd'hui",
      "fr_tu" : "Voici comment tu te positionnes aujourd'hui",
      "en" : "Here is where you stand today",
    },
    /* MEDIANE DE COHORTE — node Figma 4:1458, legende 14px sous le score.
       Le libelle s'arrete avant la valeur : celle-ci est un NOMBRE calcule,
       concatene a l'affichage. Ne pas y glisser de gabarit a trous, le reste
       du dictionnaire n'en utilise pas et on ne cree pas un mecanisme pour
       une ligne.
       ⚠️ Formulation NON ARBITREE PAR NAWAL. C'est la reprise litterale de la
       maquette de Valentin, pas une decision editoriale validee. */
    medianeCohorte : {
      "fr" : "Médiane de la cohorte\u00a0:",
      "en" : "Cohort median:",
    },
    /* Titre de la liste de competences du Diagnostic, node Figma de la planche
       14 : « Vos six compétences, du plus au moins solide: ». Le NOMBRE y est
       ecrit, donc la phrase est dynamique — `{n}` est remplace par le nombre
       de competences reellement affichees.
       ⚠️ Deux points laisses a l'arbitrage de Nawal, signales et non tranches
       seul : le nombre est rendu en CHIFFRES (la planche l'ecrit en lettres,
       intenable pour un nombre variable), et l'accord « du plus au moins » est
       repris tel quel de la planche bien que « compétences » soit feminin. */
    /* Libelle de section de la Fin de module, planche 15 : « Voici tes
       résultats : ». Il manquait, et la liste de resultats arrivait sans etre
       annoncee. Purement visuel. */
    voiciTesResultats : {
      "fr" : "Voici vos résultats\u00a0:",
      "fr_tu" : "Voici tes résultats\u00a0:",
      "en" : "Here are your results:",
    },
    /* Etiquette du bloc module, planche 15. Le NOM du module n'y est PAS
       repris : la formulation validee avec Nawal se termine par un
       deux-points qui appelle ce nom, il reste donc dans la continuite du
       titre. Le bloc de droite garde la vignette et son etiquette. */
    etiquetteModule : {
      "fr" : "Module",
      "en" : "Module",
    },
    vosCompetences : {
      "fr" : "Vos {n} compétences, du plus au moins solide\u00a0:",
      "fr_tu" : "Tes {n} compétences, du plus au moins solide\u00a0:",
      "en" : "Your {n} skills, from strongest to weakest:",
    },
    /* Infobulle du bouton qui ouvre le plan du module, dans l'en-tete du
       lecteur. Meme defaut que `scoreGlobal`, trouve par le meme test le
       18/09 : la cle etait appelee sans jamais avoir ete declaree. Elle avait
       un repli ecrit en dur, donc rien ne cassait — mais ce repli est en
       FRANCAIS, et il s'affichait tel quel a un apprenant anglophone. */
    voirLePlan : {
      "fr" : "Voir le plan du module",
      "en" : "View the module outline",
    },
    /* Point 11 de la revue apprenant : la mention n'existait que pour le choix
       MULTIPLE. L'apprenant qui ne la voyait pas ne pouvait pas savoir s'il
       s'agissait d'une omission ou d'une reponse unique. Les deux cas sont
       desormais nommes. */
    /* Point 12 de la revue apprenant : deux indicateurs coexistaient en bas de
       l'ecran et affichaient des valeurs differentes — 50 % pour l'un, 1 % pour
       l'autre — sans que rien ne dise qu'ils mesurent deux choses. La barre
       pleine largeur suit le CHAPITRE en cours, la petite suit le MODULE
       entier. Ils sont nommes, et un decompte d'ecrans remplace utilement un
       pourcentage seul. */
    /* Point 3 de la revue apprenant : l'apprenant terminait son module sans un
       mot — l'illustration, puis directement le bouton. Le Figma place ici un
       titre de felicitations avec le nom du module.
       ⚠️ Uniquement dans THE LAB : le meme lecteur sert a THE SCAN, ou ce
       message n'a pas lieu d'etre. */
    /* Legende du code couleur du bilan. Proposee le 07/09 hors fiche, VALIDEE
       par Nawal le meme jour (fiche V2, point 1.6) : « la couleur ne doit
       jamais porter l'information seule », d'autant que RdYlGn n'est pas
       lisible par les personnes atteintes de deficience de la vision des
       couleurs rouge et vert. C'est le mot qui fait foi.
       ⚠️ « Acquis » a ete REFUSE : le cadre scientifique de Rising Up tient
       les core skills pour des capacites entrainables, pas pour des etats
       atteints une fois pour toutes, et c'est exactement ce qu'il ne faut pas
       dire a quelqu'un qui commence une formation. Les trois mots ci-dessous
       sont ceux qu'elle a arretes, a ne pas reformuler.
       06/10/2026 (review de Nawal du 5 oct, point 4.3) : le palier du milieu
       passe de « En développement » / « Developing » a « À consolider » /
       « To strengthen », arrete par elle. */
    niveauAcquis : {
      "fr" : "Point fort",
      "en" : "Strength",
    },
    niveauEnCours : {
      "fr" : "À consolider",
      "en" : "To strengthen",
    },
    niveauATravailler : {
      "fr" : "À travailler",
      "en" : "To work on",
    },
    /* Bouton de fin de module. La regle des trois libelles de Nawal (Valider,
       Continuer, Suivant) ne couvre pas ce bouton, qui ramene au tableau de
       bord. Tranche par Hicham le 07/09 : libelle CALCULE comme les autres,
       plutot que celui saisi par l'ecole, pour qu'il ne derive pas. */
    /* Format « Feedback » porte de l'ancien lecteur (07/09) : le compte de
       bonnes reponses depuis le dernier bilan. */
    /* Video illisible : 18 des 90 videos du catalogue importe ne repondent
       plus cote Mux. On le dit, et on laisse passer. */
    videoIndisponible : {
      "fr" : "Cette vidéo n'est pas disponible pour le moment. Vous pouvez continuer.",
      "fr_tu" : "Cette vidéo n'est pas disponible pour le moment. Tu peux continuer.",
      "en" : "This video is unavailable right now. You can continue.",
    },
    feedbackBonnesReponses : {
      "fr" : "{n} bonne(s) réponse(s) sur {total} depuis le dernier point d'étape.",
      "en" : "{n} correct answer(s) out of {total} since the last checkpoint.",
    },
    /* 30/09/2026 — fiche de retour de Nawal, point 9 : le bouton de la derniere
       slide dit « Retour au dashboard », et non « Retour au tableau de bord ».
       Le mot « dashboard » est celui employe partout ailleurs cote apprenant
       (la page s'appelle le dashboard) ; l'anglais etait deja juste. */
    /* ⛔ 01/10/2026 — REPERES CLAVIER (point 3 d'Hicham : « la navigation avec
       les fleches sur tous les formats comme dans le design figma »).
       51 planches sur 96 posent une touche DESSINEE en bas a gauche de la barre
       d'action, suivie d'un libelle : nodes « Alphabet » + le TEXT qui suit.
       Les quatre libelles releves, mot pour mot, dans le fichier « Claude » :
         « pour valider »   (02, 03, 04, 05, 07, 09, 10, 11)
         « pour continuer » (06)
         « pour choisir »   (08, 10 — precede de la touche « 1-4 »)
         « pour ouvrir »    (06', precede de la touche « Espace »)
       On reprend les libelles tels quels ; l'anglais est une traduction, pas un
       releve. */
    toucheValider : {
      "fr" : "pour valider",
      "en" : "to submit",
    },
    toucheContinuer : {
      "fr" : "pour continuer",
      "en" : "to continue",
    },
    /* Diagnostic, EDITEUR seulement : texte indicatif du champ de palier vide,
       dans la slide (review de Nawal du 5 oct, point 3.1). `{seuil}` est remplace
       par « 33 % ». ⚠️ L'anglais est une proposition, a relire par Nawal. */
    diagTexteSiScore : {
      "fr" : "Texte affiché si le score est ≥\u00a0{seuil}",
      "en" : "Text shown if the score is ≥\u00a0{seuil}",
    },
    /* 07/10/2026 : format « Fin de module » (Formats/FormatFinDeModule.js),
       fiche Notion de Nawal, partie B. Libelle de la rosette : le module est
       valide si son score (glbMaster) depasse le seuil du certificat. Aucun
       vocabulaire d'echec. Textes neutres (ni tu ni vous) ; ils passent quand
       meme par `useTexte`, une forme `fr_tu` ajoutee ici serait donc suivie.
       ⚠️ L'anglais est une proposition, a relire par Nawal. */
    finModuleValide : {
      "fr" : "Validé",
      "en" : "Validated",
    },
    finModulePasEncoreValide : {
      "fr" : "Pas encore validé",
      "en" : "Not yet validated",
    },
    /* Fin de module : titre en haut a gauche (a la place de celui du
       Diagnostic), tant que Nawal n'en a pas ecrit un dans le panneau.
       ⚠️ L'anglais est une proposition, a relire par Nawal. */
    finModuleTitre : {
      "fr" : "Votre résultat pour ce module",
      "fr_tu" : "Ton résultat pour ce module",
      "en" : "Your result for this module",
    },
    /* Fin de module, « pas encore validé » : le texte tant que Nawal n'en a
       pas ecrit (et son texte indicatif dans l'editeur). Texte de Nawal du
       07/10 : la plateforme propose un rattrapage. ⛔ Jamais de consigne du
       type « refais les videos ». */
    finModulePasEncoreValideDefaut : {
      "fr" : "Un module de rattrapage vous sera proposé.",
      "fr_tu" : "Un module de rattrapage te sera proposé.",
      "en" : "A catch-up module will be offered to you.",
    },
    /* Fin de module, « validé », EDITEUR seulement : texte indicatif du champ
       vide, dans la slide (le texte est vide par defaut). `{seuil}` est
       remplace par « 50 % ». */
    finModuleTexteSiValide : {
      "fr" : "Texte affiché si le module est validé (score du module supérieur à {seuil})",
      "en" : "Text shown if the module is validated (module score above {seuil})",
    },
    /* Video, premiere lecture : affiche cinq secondes quand l'apprenant tente
       d'avancer dans la barre (FormatVideo, `messagePedago`). Texte de Nawal,
       review du 5 oct, point 1.4 ; anglais de Nawal (lot 3). */
    videoSansAvance : {
      "fr" : "Moins de 2 minutes, promis\u00a0! Chaque vidéo a été pensée comme une petite étape du parcours. Regardez-la jusqu'au bout, et on continue juste après.",
      "fr_tu" : "Moins de 2 minutes, promis\u00a0! Chaque vidéo a été pensée comme une petite étape du parcours. Regarde-la jusqu'au bout, et on continue juste après.",
      "en" : "Under 2 minutes, promise! Each video is designed as a small step in your learning journey. Watch it to the end, and we'll pick up right after.",
    },
    toucheChoisir : {
      "fr" : "pour choisir",
      "en" : "to choose",
    },
    retourDashboard : {
      "fr" : "Retour au dashboard",
      "en" : "Back to dashboard",
    },
    felicitations : {
      "fr" : "Félicitations, vous avez terminé votre module\u00a0:",
      "fr_tu" : "Félicitations, tu as terminé ton module\u00a0:",
      "en" : "Congratulations, you have completed your module:",
    },
    progressionSequence : {
      "fr" : "Séquence",
      "en" : "Sequence",
    },
    progressionModule : {
      "fr" : "Module",
      "en" : "Module",
    },
    ecranSur : {
      "fr" : "écran",
      "en" : "screen",
    },
    motSur : {
      "fr" : "sur",
      "en" : "of",
    },
    singleAnswer : {
      "fr" : "Une seule réponse",
      "en" : "One answer only",
    },
    multipleAnswers : {
      "fr" : "Plusieurs réponses sont possibles",
      "en" : "Several answers are possible"
    },
    formatVideo : {
      buttonNext : {
        "fr" : "Suivant",
        "en" : "Next",
      },
    },
    planCours : {
      completed : {
        "fr" : "Complété",
        "en" : "Completed",
      },
      comingUp : {
        "fr" : "À suivre",
        "en" : "Coming up",
      },
    },
  },
  formats : {
    "Titre" : {
      "fr" : "Titre",
      "en" : "Title",
    },
    "Texte" : {
      "fr" : "Intro",
      "en" : "Intro"
    },
    "Video" : {
      "fr" : "Vidéo",
      "en" : "Video"
    },
    "Quizz" : {
      "fr" : "Quizz",
      "en" : "Quizz",
    },
    "QuestionnaireV2" : {
      "fr" : "Question",
      "en" : "Question",
    },
    "Diagnostic" : {
      "fr" : "Diagnostique",
      "en" : "Diagnostic",
    },
    "InputTexte" : {
      "fr" : "Champ texte",
      "en" : "Text field"
    },
  },
  myCertif : {
    pageTitle : {
      "fr" : "Ma certification",
      "en" : "My certification",
    },
    homeWelcome : {
      "fr" : "Votre chemin vers la certification",
      "fr_tu" : "Ton chemin vers la certification",
      "en" : "Your path to certification",
    },
    /* ⛔ POINT 64 DE LA FICHE V2. Cette ligne disait « Bienvenue dans votre
       dashboard personnalisé » sur une page qui n'est pas le dashboard : le
       texte avait ete recopie tel quel depuis l'accueil. Ne pas y remettre le
       mot « dashboard ».
       ⚠️ Formulation PROVISOIRE : Nawal a ecrit « je te le fournis, c'est du
       contenu ». A remplacer par sa version des qu'elle l'envoie. */
    homeWelcomeSub : {
      "fr" : "Suivez votre progression vers la certification, compétence par compétence.",
      "fr_tu" : "Suis ta progression vers la certification, compétence par compétence.",
      "en" : "Track your progress towards certification, skill by skill.",
    },
    /* POINT 63 : le titre et le sous-titre s'affichaient DEUX fois sur le meme
       ecran, en tete de page et a nouveau dans la carte, a quelques
       centimetres. La carte porte desormais son propre intitule, qui dit ce
       qu'elle montre. */
    cardTitle : {
      "fr" : "Votre profil de compétences",
      "fr_tu" : "Ton profil de compétences",
      "en" : "Your skills profile",
    },
    /* ⛔ POINT 65. Le modal reprenait le texte de l'espace CLIENT : « suivre,
       mesurer et certifier les competences de vos groupes ». Un apprenant n'a
       pas de groupes, il a ses propres competences. Les deux espaces ont
       desormais chacun leur texte, il ne faut plus les partager.
       ⚠️ Formulation PROVISOIRE, meme reserve qu'au point 64. */
    tutoTitle : {
      "fr" : "Une petite introduction",
      "en" : "A little introduction",
    },
    tutoSubTitle : {
      "fr" : "En 90 secondes, découvrez comment votre certification se construit, compétence après compétence.",
      "fr_tu" : "En 90 secondes, découvre comment ta certification se construit, compétence après compétence.",
      "en" : "In 90 seconds, see how your certification is built, one skill at a time.",
    },
    year : {
      "fr" : "Année",
      "en" : "Year",
    },
    skillsList : {
      "fr" : "Liste des soft skills",
      "en" : "List of soft skills"
    },
    buttonDownload : {
      "fr" : "Télécharger le certificat",
      "en" : "Download certificate",
    },
    /* PD-11 (25/09/2026, decision d'Hicham) : le vrai certificat n'est pas
       encore concu. Parcours fini, le bouton le dit au lieu de telecharger la
       maquette. `buttonDownload` reste pour le jour ou il le sera. */
    buttonComingSoon : {
      "fr" : "Certificat bientôt disponible",
      "en" : "Certificate coming soon",
    },
    /* 06/10/2026, Nawal, AU MOT PRES : l'etablissement n'a pas souscrit la
       certification (voir utils/accesCertification.js). B2B2C : jamais
       « votre plan », « votre abonnement », « offre superieure ». */
    nonDisponibleTitre : {
      "fr" : "Certification non disponible dans votre parcours",
      "fr_tu" : "Certification non disponible dans ton parcours",
      "en" : "Certification not available in your program",
    },
    nonDisponibleTexte : {
      "fr" : "Cet espace n'est pas inclus dans le parcours proposé par votre établissement.",
      "fr_tu" : "Cet espace n'est pas inclus dans le parcours proposé par ton établissement.",
      "en" : "This space is not included in the program offered by your institution.",
    },
    buttonNotAvailable : {
      "fr" : "Disponible à la fin",
      "en" : "Available at the end",
    },
    tuto : {
      "fr" : "Quelques explications...",
      "en" : "Some explanations...",
    },
    certificateName : {
      "fr" : "Certificat",
      "en" : "Certificate",
    }
  },
  /* 06/10/2026 : le CERTIFICAT DE REUSSITE d'un module (components/ui/
     Certificat). Etape 2 : affiche depuis la fin de module et « Mon
     résultat » ; « Délivré le » + date du telechargement (decision de Nawal).
     Textes de Nawal ; les traductions anglaises sont a valider. */
  certificatReussite : {
    mention : {
      "fr" : "Certificat de réussite",
      "en" : "Certificate of achievement",
    },
    atteste : {
      "fr" : "Ce certificat atteste que",
      "en" : "This certifies that",
    },
    phrase : {
      "fr" : "a complété avec succès le module",
      "en" : "has successfully completed the module",
    },
    delivreLe : {
      "fr" : "Délivré le",
      "en" : "Issued on",
    },
    voir : {
      "fr" : "Voir mon certificat",
      "en" : "See my certificate",
    },
    telecharger : {
      "fr" : "Télécharger mon certificat",
      "en" : "Download my certificate",
    },
    emetteur : {
      "fr" : "Organisme émetteur",
      "en" : "Issued by",
    },
    /* 07/10/2026 : « Dr » devant le nom, demandé par Nawal (sans point, à la
       française), comme sur le bilan soft skills. */
    signataireNom : {
      "fr" : "Dr Nawal Abboub",
      "en" : "Dr Nawal Abboub",
    },
    signataireFonction : {
      "fr" : "Directrice scientifique de Rising Up",
      "en" : "Scientific Director, Rising Up",
    },
    exemple : {
      "fr" : "Exemple, données fictives",
      "en" : "Sample, fictitious data",
    },
    nomFichier : {
      "fr" : "certificat-de-reussite",
      "en" : "certificate-of-achievement",
    },
  },
  /* 07/10/2026 : le BILAN SOFT SKILLS (components/ui/Bilan). v2 du 07/10 : DEUX pages, la
     « vitrine » (page 1, a partager, que des forces) et « Prépare ton
     entretien » (page 2, pour l'apprenant seul), plus une image de partage.
     Les textes propres a chaque competence ne sont PAS ici : ils viennent de
     la bibliotheque des 18 fiches (Bilan/bibliotheque_18_competences.json).
     Ici, seulement les libelles des pages, du tampon et de la ligne du
     tableau de bord. « Délivré le », la signature et la marque d'exemple sont
     ceux du certificat (certificatReussite).
     A FAIRE VALIDER PAR NAWAL : « Ce que tu as gagné » (texte propose par
     elle, a valider), « Ta prochaine marche », le texte du tampon ; les
     traductions anglaises aussi.
     TU OU VOUS : le mecanisme publie (utils/formeAdresse.js, choisirTexte) :
     `fr` = vous, `fr_tu` = tu, `en_tu` seulement quand l'anglais differe. Le
     public du bilan suit la forme d'adresse : tu = etudiant, vous =
     professionnel. La signature est celle du certificat (certificatReussite,
     « Dr Nawal Abboub »).
     ETAPE 2 (07/10) : BRANCHE sur le tableau de bord (Dashboard.js). */
  bilanSoftSkills : {
    mention : {
      "fr" : "Bilan soft skills",
      "en" : "Soft skills report",
    },
    /* v4 du 07/10 (Nawal) : les competences ne sont pas declarees, elles
       ressortent d'une EVALUATION ; aucune ambiguite avec la certification */
    accomplissement : {
      "fr" : "a évalué ses soft skills et appris à mieux les comprendre et les valoriser",
      "en" : "has assessed their soft skills and learned to understand and showcase them better",
    },
    parcours : {
      "fr" : "Parcours",
      "en" : "Programme",
    },
    atouts : {
      "fr" : "Mes 3 atouts",
      "en" : "My 3 strengths",
    },
    atoutsCles : {
      "fr" : "Mes 3 soft skills clefs",
      "en" : "My 3 key soft skills",
    },
    atoutsEmployeur : {
      "fr" : "Ses 3 soft skills clefs",
      "en" : "Their 3 key soft skills",
    },
    partageMessageLong : {
      "fr" : "a évalué ses soft skills avec les Soft Skills Scans de Rising Up",
      "en" : "has assessed their soft skills with the Rising Up Soft Skills Scans",
    },
    partageMessageCourt : {
      "fr" : "a évalué ses soft skills avec Rising Up",
      "en" : "has assessed their soft skills with Rising Up",
    },
    gagneTitre : {
      "fr" : "Ce que vous avez gagné",
      "fr_tu" : "Ce que tu as gagné",
      "en" : "What you have gained",
    },
    gagneTexte : {
      "fr" : "Vous avez maintenant les mots pour parler de vos compétences clefs. Vous êtes capable de les présenter avec assurance, en entretien comme dans votre parcours professionnel.",
      "fr_tu" : "Tu as maintenant les mots pour parler de tes compétences clefs. Tu es capable de les présenter avec assurance, en entretien comme sur ton CV.",
      "en" : "You now have the words to talk about your key skills. You can present them with confidence, in an interview as well as throughout your career.",
      "en_tu" : "You now have the words to talk about your key skills. You can present them with confidence, in an interview as well as on your CV.",
    },
    entretienTitre : {
      "fr" : "Préparez votre entretien",
      "fr_tu" : "Prépare ton entretien",
      "en" : "Prepare your interview",
    },
    prepareExemple : {
      "fr" : "Préparez votre exemple",
      "fr_tu" : "Prépare ton exemple",
      "en" : "Prepare your example",
    },
    cv : {
      "fr" : "Pour votre CV",
      "fr_tu" : "Pour ton CV",
      "en" : "For your CV",
    },
    prochaineMarche : {
      "fr" : "Votre prochaine marche",
      "fr_tu" : "Ta prochaine marche",
      "en" : "Your next step",
    },
    /* le tampon : en haut et en bas de son cercle */
    tamponHaut : {
      "fr" : "Profil évalué par Rising Up",
      "en" : "Profile assessed by Rising Up",
    },
    tamponBas : {
      "fr" : "Bilan soft skills",
      "en" : "Soft skills report",
    },
    /* v4 : « Mes 3 soft skills clefs » au lieu de « Mes 3 atouts », pour la
       coherence avec l'image (Nawal peut revenir en arriere).
       v3 du 07/10 : TROIS VERSIONS (Nawal). « Pour LinkedIn » : l'image et un
       texte de post a la PREMIERE personne ({parcours}, {atouts} : les trois
       noms d'usage a la premiere personne, Bilan/partageBilan.js). « Pour
       un employeur » : une page a la TROISIEME personne. Textes a valider. */
    postLinkedIn : {
      "fr" : "Je viens de terminer le parcours «\u00a0{parcours}\u00a0» avec Rising Up. Mes 3 soft skills clefs\u00a0: {atouts}. Prochaine étape\u00a0: les mettre au service de mon équipe et de mes projets\u00a0!",
      "fr_tu" : "Je viens de terminer le parcours «\u00a0{parcours}\u00a0» avec Rising Up. Mes 3 soft skills clefs\u00a0: {atouts}. Prochaine étape\u00a0: les mettre au service de mon futur employeur\u00a0!",
      "en" : "I have just completed the “{parcours}” programme with Rising Up. My 3 key soft skills: {atouts}. Next step: putting them to work for my team and my projects!",
      "en_tu" : "I have just completed the “{parcours}” programme with Rising Up. My 3 key soft skills: {atouts}. Next step: putting them to work for my future employer!",
    },
    /* etape 2 : sans titre du plan dans les donnees de l'apprenant, le post
       ne cite pas de parcours (aucune valeur inventee) */
    postLinkedInSansParcours : {
      "fr" : "Je viens de terminer mon parcours soft skills avec Rising Up. Mes 3 soft skills clefs\u00a0: {atouts}. Prochaine étape\u00a0: les mettre au service de mon équipe et de mes projets\u00a0!",
      "fr_tu" : "Je viens de terminer mon parcours soft skills avec Rising Up. Mes 3 soft skills clefs\u00a0: {atouts}. Prochaine étape\u00a0: les mettre au service de mon futur employeur\u00a0!",
      "en" : "I have just completed my soft skills programme with Rising Up. My 3 key soft skills: {atouts}. Next step: putting them to work for my team and my projects!",
      "en_tu" : "I have just completed my soft skills programme with Rising Up. My 3 key soft skills: {atouts}. Next step: putting them to work for my future employer!",
    },
    postEt : {
      "fr" : "et",
      "en" : "and",
    },
    postMotsCles : {
      "fr" : "#SoftSkills #RisingUp",
      "en" : "#SoftSkills #RisingUp",
    },
    competencesProfil : {
      "fr" : "Pour la rubrique «\u00a0Compétences\u00a0» de votre profil LinkedIn\u00a0:",
      "fr_tu" : "Pour la rubrique «\u00a0Compétences\u00a0» de ton profil LinkedIn\u00a0:",
      "en" : "For the “Skills” section of your LinkedIn profile:",
    },
    employeurPhrase : {
      "fr" : "a évalué ses soft skills et appris à les valoriser dans un contexte professionnel",
      "en" : "has assessed their soft skills and learned to showcase them in a professional context",
    },
    qrAVenir : {
      "fr" : "[QR de vérification, à venir]",
      "en" : "[Verification QR code, coming soon]",
    },
    /* la fenetre « Voir mon bilan » : trois onglets */
    ongletLinkedIn : {
      "fr" : "Pour LinkedIn",
      "en" : "For LinkedIn",
    },
    ongletMoi : {
      "fr" : "Pour moi",
      "en" : "For me",
    },
    ongletEmployeur : {
      "fr" : "Pour un employeur",
      "en" : "For an employer",
    },
    aideLinkedIn : {
      "fr" : "Montrez vos forces\u00a0: l’image et le texte de votre post, prêts à partager.",
      "fr_tu" : "Montre tes forces\u00a0: l’image et le texte de ton post, prêts à partager.",
      "en" : "Show your strengths: the image and the text of your post, ready to share.",
    },
    aideMoi : {
      "fr" : "Pour progresser\u00a0: vos atouts, votre préparation d’entretien et votre prochaine marche.",
      "fr_tu" : "Pour progresser\u00a0: tes atouts, ta préparation d’entretien et ta prochaine marche.",
      "en" : "To keep progressing: your strengths, your interview preparation and your next step.",
    },
    aideEmployeur : {
      "fr" : "Une page sobre, pour une candidature, un entretien annuel ou une mobilité.",
      "fr_tu" : "Une page sobre, à joindre à une candidature.",
      "en" : "A plain page for an application, an annual review or a mobility request.",
      "en_tu" : "A plain page to attach to an application.",
    },
    texteDuPost : {
      "fr" : "Texte du post",
      "en" : "Post text",
    },
    telechargerImage : {
      "fr" : "Télécharger l’image",
      "en" : "Download the image",
    },
    copierPost : {
      "fr" : "Copier le texte du post",
      "en" : "Copy the post text",
    },
    postCopie : {
      "fr" : "Texte copié",
      "en" : "Text copied",
    },
    telechargerPdf : {
      "fr" : "Télécharger le PDF",
      "en" : "Download the PDF",
    },
    /* v4 : les deux mentions du pied de page, a la place de l'ancienne */
    mentionMethode : {
      "fr" : "Résultats issus des Soft Skills Scans de Rising Up, fondés sur une méthodologie propriétaire développée à partir de la recherche scientifique en sciences cognitives.",
      "en" : "Results from the Rising Up Soft Skills Scans, based on a proprietary methodology developed from scientific research in cognitive science.",
    },
    mentionCertification : {
      "fr" : "Ce bilan ne constitue pas une certification de niveau de maîtrise.",
      "en" : "This report does not constitute a certification of proficiency level.",
    },
    mentionMethodeCourte : {
      "fr" : "Soft Skills Scans fondés sur une méthodologie propriétaire développée à partir de la recherche scientifique en sciences cognitives.",
      "en" : "Soft Skills Scans based on a proprietary methodology developed from scientific research in cognitive science.",
    },
    provisoire : {
      "fr" : "[PROVISOIRE]",
      "en" : "[DRAFT]",
    },
    nomFichier : {
      "fr" : "bilan-soft-skills",
      "en" : "soft-skills-report",
    },
    /* la derniere etape de « Votre programme » (tableau de bord) */
    ligneTitre : {
      "fr" : "Mon bilan soft skills",
      "en" : "My soft skills report",
    },
    ligneVerrouillee : {
      "fr" : "Disponible à la fin de votre parcours",
      "fr_tu" : "Disponible à la fin de ton parcours",
      "en" : "Available at the end of your programme",
    },
    ligneDisponible : {
      "fr" : "Votre bilan est prêt",
      "fr_tu" : "Ton bilan est prêt",
      "en" : "Your report is ready",
    },
    /* parcours termine, mais moins de 3 competences du referentiel mesurees */
    ligneIncomplete : {
      "fr" : "Disponible lorsque vos résultats seront complets",
      "fr_tu" : "Disponible lorsque tes résultats seront complets",
      "en" : "Available once your results are complete",
    },
    voir : {
      "fr" : "Voir mon bilan",
      "en" : "See my report",
    },
    telecharger : {
      "fr" : "Télécharger mon bilan",
      "en" : "Download my report",
    },
  },
  dashboard : {
    /* Tutoiement / vouvoiement (07/10/2026) : la ligne d'accueil de
       l'apprenant avait la cle de l'espace client
       (`adminDashboard.homeWelcomeSub`). Cle propre a l'apprenant, pour que sa
       forme « tu » ne touche pas l'espace client, qui garde la sienne. */
    bienvenueSousTitre : {
      "fr" : "Bienvenue dans votre dashboard personnalisé.",
      "fr_tu" : "Bienvenue dans ton dashboard personnalisé.",
      "en" : "Welcome to your personalized dashboard.",
    },
    yourProgram : {
      "fr" : "Votre programme",
      "fr_tu" : "Ton programme",
      "en" : "Your program",
    },
    expertDesc : {
      "fr" : "Docteur en Neurosciences",
      "en" : "Doctor in Neurosciences",
    },
    resources : {
      "fr" : "Ressources",
      "en" : "Resources",
    },
    myStats : {
      "fr" : "Mes stats",
      "en" : "My stats",
    },
    resultModal : {
      title : {
        "fr" : "Mon résultat",
        "en" : "My result",
      },
    },
    resourcesCard : {
      title : {
        "fr" : "Plus d'infos sur les soft skills",
        "en" : "Learn more about soft skills",
      },
      subTitle : {
        "fr" : "Consultez la liste soft skills et comment nous les évaluons",
        "fr_tu" : "Consulte la liste soft skills et comment nous les évaluons",
        "en" : "View the list of soft skills and how we calculate them",
      },
      dictionary : {
        "fr" : "Dictionnaire des soft skills",
        "en" : "Soft skills dictionary",
      }
    },
    cards : {
      modulesAverage : {
        "fr" : "Moy. des modules",
        "en" : "Modules average",
      },
      modules : {
        "fr" : "Modules",
        "en" : "Modules",
      },
      progression : {
        "fr" : "Progression",
        "en" : "Progression",
      },
      groupeAverage : {
        "fr" : "Moyenne groupe",
        "en" : "Group average",
      },
      softSkills : {
        "fr" : "Soft skills",
        "en" : "Soft skills",
      },
      time : {
        "fr" : "Moy. temps passé",
        "en" : "Average time",
      },
    },
    stepper : {
      completed : {
        "fr" : "Complété",
        "en" : "Completed",
      },
      closed : {
        "fr" : "Fermé",
        "en" : "Closed",
      },
      daysLeft : {
        "fr" : " jours restants",
        "en" : " days left",
      },
      hoursLeft : {
        "fr" : "Quelques heures restantes",
        "en" : "Few hours remaining",
      },
      seeResultsBtn : {
        "fr" : "Voir résultats",
        "en" : "See results",
      },
      startBtn : {
        "fr" : "Commencer",
        "en" : "Start",
      },
      resumeBtn : {
        "fr" : "Reprendre",
        "en" : "Resume",
      },
      /* PD-17 (02/10/2026) : l'apprenant suit l'ordre de son plan. Un module
         qui n'est pas le module en cours garde son bouton, GRISE, et la
         raison est ecrite dessous (Dashboard.js, SteppedCard). */
      moduleVerrouille : {
        "fr" : "Vous pourrez accéder à ce module une fois le précédent terminé.",
        "fr_tu" : "Tu pourras accéder à ce module une fois le précédent terminé.",
        "en" : "You can access this module once the previous one is completed.",
      },
      /* 30/09/2026 — fiche de retour de Nawal, point 3 : la raison quand le
         module en cours est l'icebreaker. Depuis PD-17, titre et detail se
         lisent d'affilee sous le bouton grise (« Commencez par votre
         icebreaker avant de démarrer votre formation »). Registre : selon la
         cible du module en cours depuis le 07/10/2026 (vous par defaut,
         `fr_tu` pour un module Ecole ; utils/formeAdresse.js). */
      icebreakerDabordTitre : {
        "fr" : "Commencez par votre icebreaker",
        "fr_tu" : "Commence par ton icebreaker",
        "en" : "Start with your icebreaker",
      },
      icebreakerDabordDetail : {
        "fr" : "avant de démarrer votre formation",
        "fr_tu" : "avant de démarrer ta formation",
        "en" : "before starting your training",
      },
    },
  },
  /* Tutoiement / vouvoiement (07/10/2026) : les textes de la visite guidee
     de l'apprenant, jusque-la ecrits en dur dans Dashboard.js
     (ETAPES_APPRENANT). Memes textes, memes etapes. */
  visiteApprenant : {
    moduleTitre : {
      "fr" : "Votre module commence ici",
      "fr_tu" : "Ton module commence ici",
      "en" : "Your module starts here",
    },
    moduleTexte : {
      "fr" : "Vous pouvez le quitter et le reprendre quand vous voulez\u00a0: votre progression est enregistrée à chaque écran.",
      "fr_tu" : "Tu peux le quitter et le reprendre quand tu veux\u00a0: ta progression est enregistrée à chaque écran.",
      "en" : "You can leave and come back whenever you want: your progress is saved on every screen.",
    },
    resultatsTitre : {
      "fr" : "Vos résultats",
      "fr_tu" : "Tes résultats",
      "en" : "Your results",
    },
    resultatsTexte : {
      "fr" : "Vos compétences se construisent au fil des modules. Vous les retrouvez ici, module après module.",
      "fr_tu" : "Tes compétences se construisent au fil des modules. Tu les retrouves ici, module après module.",
      "en" : "Your skills build up module after module. You will find them here.",
    },
    departTitre : {
      "fr" : "Votre point de départ",
      "fr_tu" : "Ton point de départ",
      "en" : "Your starting point",
    },
    departTexte : {
      "fr" : "Cette page rassemble vos modules et vous ramène toujours là où vous vous étiez arrêté.",
      "fr_tu" : "Cette page rassemble tes modules et te ramène toujours là où tu t'étais arrêté.",
      "en" : "This page gathers your modules and always brings you back to where you stopped.",
    },
    terminer : {
      "fr" : "J'ai compris",
      "en" : "Got it",
    },
  },
  /* Tutoiement / vouvoiement (07/10/2026) : les alertes du navigateur emises
     par UserContext, jusque-la ecrites en dur. Elles n'ont jamais eu de
     version anglaise : UserContext lit toujours le francais, l'anglais ne
     change donc pas. L'alerte « reponse non enregistree » reprend
     `formation.reponseNonEnregistree`, dont elle etait le doublon. */
  alertesApprenant : {
    sessionExpiree : {
      "fr" : "Votre session a expiré\u00a0: votre dernière réponse n'a pas été enregistrée. Reconnectez-vous\u00a0; vous reprendrez là où l'enregistrement s'est arrêté.",
      "fr_tu" : "Ta session a expiré\u00a0: ta dernière réponse n'a pas été enregistrée. Reconnecte-toi\u00a0; tu reprendras là où l'enregistrement s'est arrêté.",
    },
    progressionNonEnregistree : {
      "fr" : "Votre réponse est bien enregistrée, mais votre progression n'a pas pu l'être. Vérifiez votre connexion\u00a0: elle sera renvoyée à l'écran suivant.",
      "fr_tu" : "Ta réponse est bien enregistrée, mais ta progression n'a pas pu l'être. Vérifie ta connexion\u00a0: elle sera renvoyée à l'écran suivant.",
    },
  },
  onBoarding : {
    title : {
      "fr" : "Entrez vos informations",
      "fr_tu" : "Entre tes informations",
      "en" : "Enter your information",
    },
    sexe : {
      "fr" : "Sexe",
      "en" : "Gender",
    },
    age : {
      "fr" : "Date de naissance",
      "en" : "Date of birth",
    },
    sexeFemme : { // L70
      "fr" : "Une Femme",
      "en" : "A Woman",
    },
    sexeHomme : { // L70
      "fr" : "Un Homme",
      "en" : "A Man",
    }
  },
  errorLogin : { //errorLogin page
    title : {
      "fr": "Une erreur est survenue",
      "en" : "An error has occurred",
    },
    texte : {
      "fr" : "Nous sommes désolés mais votre compte n’existe pas.\n\nRapprochez-vous de votre école pour lui signaler ce problème et qu’elle puisse créer votre compte rapidement.",
      "en" : "We're sorry but your account does not exist.\n\nContact your school to report this problem to them so they can create your account quickly.",
    },
    button : {
      "fr" : "Retour",
      "en" : "Back",
    },
  },
  noAccess : { //noAccess page
    title : {
      "fr": "Une erreur est survenue",
      "en" : "An error has occurred",
    },
    texte : {
      "fr" : "Vos droits ont expiré. Vous n’avez plus accès à ce compte.\n\nVous serez déconnecté dans quelques secondes.",
      "en" : "Your rights have expired. You no longer have access to this account.\n\nYou will be logged out in a few seconds.",
    },
    button : {
      "fr" : "Se déconnecter",
      "en" : "Log Out",
    },
  },
  myAccount : {
    title : {
      "fr" : "Compte",
      "en" : "Account",
    },
    changeNames : {
      "fr" : "Noms",
      "en" : "Names",
    },
    changePassword : {
      "fr" : "Mot de passe",
      "en" : "Password",
    },
    changeLanguage : {
      "fr" : "Langue",
      "en" : "Language",
    },
    name : {
      "fr" : "Nom",
      "en" : "Name",
    },
    poste : {
      "fr" : "Nom entreprise / école",
      "en" : "Company / School name",
    },
    oldPassword : {
      "fr" : "Mot de passe actuel",
      "en" : "Current password",
    },
    newPassword : {
      "fr" : "Nouveau mot de passe",
      "en" : "New password",
    },
    newPasswordConfirm : {
      "fr" : "Confirmer nouveau mot de passe",
      "en" : "Confirm new password",
    },
    wrongOldPassword : {
      "fr" : "Mauvais mot de passe",
      "en" : "Wrong password",
    },
  },
  studentMenu : {
    dashboard : {
      "fr" : "Dashboard",
      "en" : "Dashboard",
    },
    myCertif : {
      "fr" : "Ma certification",
      "en" : "My certification",
    },
    ressources : {
      "fr" : "Ressources",
      "en" : "Resources"
    }
  },
  globalMenu : {
    help : {
      "fr" : "Aide",
      "en" : "Help",
    },
    account : {
      "fr" : "Mon Compte",
      "en" : "My Account",
    },
    logOut : {
      "fr" : "Se déconnecter",
      "en" : "Log Out",
    },
    logOutSubTitle : {
      "fr" : "Vous allez vous déconnecter de votre compte",
      "fr_tu" : "Tu vas te déconnecter de ton compte",
      "en" : "You’re going to logout of your account",
    },
    admin : {
      "fr" : "Admin",
      "en" : "Admin",
    }
  },
  adminDashboard : {
    /* Le mot de liaison du compteur de pagination — « 1-25 sur 1250 ». Il etait
       ecrit en dur en francais dans le Suivi et dans la Certification, donc
       affiche tel quel a un compte anglophone. */
    paginationSur : {
      "fr" : "sur",
      "en" : "of",
    },
    dashCertif : {
      yearBtn : {
        "fr" : "Année ",
        "en" : "Year ",
      },
      // F6 review 03/09 : les seuils de certification dans la fiche apprenant
      seuilsTitre : {
        "fr" : "Seuils de certification (score obtenu / seuil)",
        "en" : "Certification thresholds (score achieved / threshold)",
      },
      seuilsExport : {
        "fr" : "Seuils de certification",
        "en" : "Certification thresholds",
      },
      // C2 niveau 1 : legende du trait de seuil trace dans le radar
      seuilLegende : {
        "fr" : "Seuil de certification",
        "en" : "Certification threshold",
      },
      /* C3 (retours Hicham 03/09) : la legende sous le radar nommait les trois
         annees du plan. Elle laissait croire a un seuil par annee alors qu'il
         n'y en a qu'un, et le trait plein de « Annee 3 » etait indiscernable de
         celui du seuil. Le radar n'oppose plus que deux choses : ce que
         l'apprenant a acquis, et la barre a franchir. */
      niveauAcquisLegende : {
        "fr" : "Niveau acquis",
        "en" : "Level achieved",
      },
      catEfficacite : {
        "fr" : "Efficacité\nopérationnelle",
        "en" : "Operational\nefficiency",
      },
      catInnovation : {
        "fr" : "Innovation et\ncommunication",
        "en" : "Innovation and\ncommunication",
      },
      catCollaboration : {
        "fr" : "Collaboration et\nleadership",
        "en" : "Collaboration and\nleadership",
      },
    },
    exportTable : {
      "fr" : "Exporter le tableau",
      "en" : "Export the data",
    },
    monitoringTable : {
      // D1 review 02/09 : libelle du rond de progression de la colonne Statut
      completeA : {
        "fr" : "Complété à {pct} %",
        "en" : "{pct}% completed",
      },
      oui : {
        "fr" : "Oui",
        "en" : "Yes",
      },
      non : {
        "fr" : "Non",
        "en" : "No",
      },
      rattrapage : {
        "fr" : " (R)",
        "en" : " (C)",
      },
      rattrapageExport : {
        "fr" : "Rattrapage",
        "en" : "Catch-up",
      },
      name : {
        "fr" : "Nom",
        "en" : "Name",
      },
      certification : {
        "fr" : "Certification",
        "en" : "Certification",
      },
      campus : {
        "fr" : "Campus",
        "en" : "Campus",
      },
      module : {
        "fr" : "Module",
        "en" : "Module",
      },
      score : {
        "fr" : "Statut",
        "en" : "Status",
      },
      moduleType : {
        "fr" : "Type de module",
        "en" : "Module type",
      },
      /* Retours Hicham 03/09 : le libelle de cette colonne devient « Diplome ».
         Elle porte le diplome de l'apprenant (reponse a l'icebreaker « Quel est
         votre niveau de diplome ? »), a ne pas confondre avec `graduation`
         ci-dessous, qui portait le meme mot pour le diplome DU GROUPE : les
         deux se cotoient dans la fiche apprenant de la Certification, d'ou
         deux libelles identiques a l'ecran. `graduation` n'est plus utilise,
         cette valeur s'affiche desormais sous « Certification », comme dans le
         tableau et dans l'export qui la nommaient deja ainsi. */
      sector : {
        "fr" : "Diplôme",
        "en" : "Diploma",
      },
      studyYear : {
        "fr" : "Année d'étude",
        "en" : "Year of study",
      },
      graduationYear : {
        "fr" : "Année de certification",
        "en" : "Certification year",
      },
      statusProgress : {
        "fr" : "Complété à ",
        "en" : "Completed at "
      },
      statusNotStarted : {
        "fr" : "Pas commencé",
        "en" : "Not started"
      },
      statusEnded : {
        "fr" : "Terminé",
        "en" : "Ended"
      },
      graduation : {
        "fr" : "Diplôme",
        "en" : "Graduation",
      },
      level : {
        "fr" : "Statut",
        "en" : "Status",
      },
      progress : {
        "fr" : "Progression",
        "en" : "Progression",
      },
    },
    filters : {
      addFilter : {
        "fr" : "Sélectionner Filtres",
        "en" : "Select Filters",
      },
      deleteAll : {
        "fr" : "Tout supprimer",
        "en" : "Remove all",
      },
      delete : {
        "fr" : "Vider",
        "en" : "Clear",
      },
      moduleName : {
        "fr" : "Nom du module",
        "en" : "Module name",
      },
      moduleNameSub : {
        "fr" : "Formations",
        "en" : "Training",
      },
      moduleType : {
        "fr" : "Type de module",
        "en" : "Module type",
      },
      moduleTypeSub : {
        "fr" : "Types",
        "en" : "Types",
      },
      studyYear : {
        "fr" : "Année d'étude",
        "en" : "Year of study",
      },
      studyYearSub : {
        "fr" : "Années d'études",
        "en" : "Years of study",
      },
      /* Retours Hicham 03/09 (suite du point Suivi 1). Ce libelle ne titre pas
         un filtre sur l'annee : le menu qu'il coiffe est affiche sous condition
         de `icebreakerQuestions.diplome` et sa selection est comparee au
         diplome de l'apprenant. Il annoncait « Annee de certification » au
         dessus d'une liste de diplomes. Il dit maintenant ce qu'il filtre, et
         reprend le mot retenu pour la colonne du tableau : « Diplome ». */
      graduationYear : {
        "fr" : "Diplôme",
        "en" : "Diploma",
      },
      graduationYearSub : {
        "fr" : "Diplômes",
        "en" : "Diplomas",
      },
      groupe : {
        "fr" : "Certification",
        "en" : "Certification",
      },
      groupeSub : {
        "fr" : "Certifications",
        "en" : "Certifications",
      },
      campus : {
        "fr" : "Campus",
        "en" : "Campus",
      },
      campusSub : {
        "fr" : "Campus",
        "en" : "Campus",
      },
      /* Retours Hicham 03/09 (suite du point Suivi 1). Meme erreur que
         `graduationYear` ci-dessus, dans l'autre sens : ce libelle coiffe le
         filtre `secteur`, dont la selection est comparee au secteur de
         l'apprenant. Sur le groupe de demonstration il annoncait « Nom de
         diplome » au dessus de « Droit », « Informatique / Numerique »,
         « Gestion (GEA) », « Sciences de l'ingenieur ». */
      sector : {
        "fr" : "Secteur",
        "en" : "Sector",
      },
      sectorSub : {
        "fr" : "Secteurs",
        "en" : "Sectors",
      },
      status : {
        "fr" : "Statut",
        "en" : "Status",
      },
      statusSub : {
        "fr" : "Statut",
        "en" : "Status",
      },
      level : {
        "fr" : "Statut",
        "en" : "Status",
      },
      levelSub : {
        "fr" : "Statut",
        "en" : "Status",
      },
      progress : {
        "fr" : "Progression",
        "en" : "Progression",
      },
      progressSub : {
        "fr" : "Progression",
        "en" : "Progression",
      },
    },
    contentType : {
      identif : {
        "fr" : "Évaluation",
        "en" : "Evaluation",
      },
      enrich : {
        "fr" : "Enrichissement",
        "en" : "Enrichment",
      },
      icebreaker : {
        "fr" : "Icebreaker",
        "en" : "Icebreaker",
      }
    },
    statusTypes : {
      notStarted : {
        "fr" : "Pas commencé",
        "en" : "Not started",
      },
      inProgress : {
        "fr" : "En cours",
        "en" : "In progress",
      },
      ended : {
        "fr" : "Terminé",
        "en" : "Finished",
      },
      endedInRat : {
        "fr" : "Terminé (R)",
        "en" : "Finished (C)",
      }
    },
    levelTypes : {
      notAcquired : {
        "fr" : "Non acquis",
        "en" : "Not acquired",
      },
      inProgress : {
        "fr" : "En cours",
        "en" : "In progress",
      },
      acquired : {
        "fr" : "Acquis",
        "en" : "Acquired",
      },
      rattrapage : {
        "fr" : "Rattrapage",
        "en" : "Retake",
      }
    },
    monitoringCards : {
      students : {
        "fr" : "Étudiants total",
        "en" : "Total students",
      },
      modules : {
        "fr" : "Modules",
        "en" : "Modules",
      },
      completion : {
        "fr" : "Taux de complétion",
        "en" : "Completion rate",
      },
      average : {
        "fr" : "Moyenne groupe",
        "en" : "Group average",
      },
      softSkills : {
        "fr" : "Soft skills",
        "en" : "Soft skills",
      },
      time : {
        "fr" : "Moyenne temps passé",
        "en" : "Average time spent",
      }
    },
    completionChart : {
      // D7 review 02/09 (tranche par Nawal) : le graphe s'appelle desormais
      // « Suivi des participants » ; le style Figma (aire remplie, repere
      // Aujourd'hui) viendra avec le lot design.
      title : {
        "fr" : "Suivi des participants",
        "en" : "Participant tracking",
      },
      average : {
        "fr" : "Total",
        "en" : "Total",
      },
      emptyTitle : {
        "fr" : "Aucune donnée de programme",
        "en" : "No program data",
      },
      emptySubTitle : {
        "fr" : "Commencez à suivre vos progrès en configurant votre premier programme de formation.",
        "en" : "Start tracking your progress by setting up your first training program.",
      }
    },
    softSkillsViewer : {
      emptyTitle : {
        "fr" : "Aucun soft skills",
        "en" : "No soft skills",
      },
      emptySubTitle : {
        "fr" : "Enrichissez votre profil en ajoutant les soft skills que vous souhaitez développer.",
        "en" : "Enhance your profile by adding soft skills you wish to develop.",
      }
    },
    usedSoftSkills : {
      "fr" : "Soft skills utilisés",
      "en" : "Applied soft skills",
    },
    efficaciteSkills : {
      "fr" : "Efficacité opérationnelle",
      "en" : "Operational effectiveness",
    },
    communicationSkills : {
      "fr" : "Communication et innovation",
      "en" : "Communication and innovation",
    },
    leadershipSkills : {
      "fr" : "Leadership et collaboration",
      "en" : "Leadership and collaboration",
    },
    homePage : {
      monitoringSub : {
        "fr" : "Suivez l'avancement global des participants en un coup d'œil.",
        "en" : "Track participants' overall progress at a glance.",
      },
      mappingSub : {
        "fr" : "Accédez aux indicateurs clés pour piloter vos groupes efficacement.",
        "en" : "Access the key indicators to steer your groups effectively.",
      },
      certificationSub : {
        "fr" : "Visualisez les certifications obtenues et les parcours validés.",
        "en" : "View the certifications earned and the completed paths.",
      },
      tutoTitle : {
        "fr" : "Une petite introduction",
        "en" : "A little introduction",
      },
      tutoSubTitle : {
        "fr" : "Bienvenue sur votre espace. En 90 secondes, découvrez comment suivre, mesurer et certifier les compétences de vos groupes.",
        "en" : "Welcome to your space. In 90 seconds, discover how to track, measure and certify your groups' skills.",
      },
    },
    mappingPage : {
      // Roadmap Nawal, « phrase d'insight auto » (03/09) : meme logique que la
      // phrase de synthese du Rapport d'impact, portee a l'ecran.
      insight : {
        mixte : {
          "fr" : "Sur {n} étudiant{sEtudiants}, la promotion gagne {gain} points de connaissance. Elle progresse sur {hausses} compétence{sHausses}, et se réajuste sur {baisses}.",
          "en" : "Across {n} student{sEtudiants}, the cohort gains {gain} knowledge points. It improves on {hausses} skill{sHausses}, and realigns on {baisses}.",
        },
        hausse : {
          "fr" : "Sur {n} étudiant{sEtudiants}, la promotion gagne {gain} points de connaissance et progresse sur {hausses} compétence{sHausses}.",
          "en" : "Across {n} student{sEtudiants}, the cohort gains {gain} knowledge points and improves on {hausses} skill{sHausses}.",
        },
        reajustement : {
          "fr" : "Sur {n} étudiant{sEtudiants}, la connaissance évolue de {gain} points. {baisses} compétence{sBaisses} se réajuste{sBaisses}\u00a0: les apprenants s'évaluent avec plus de justesse.",
          "en" : "Across {n} student{sEtudiants}, knowledge moves by {gain} points. {baisses} skill{sBaisses} realign{sBaisses}: learners assess themselves more accurately.",
        },
        stable : {
          "fr" : "Sur {n} étudiant{sEtudiants}, la connaissance évolue de {gain} points et les compétences restent stables sur la période.",
          "en" : "Across {n} student{sEtudiants}, knowledge moves by {gain} points and skills remain stable over the period.",
        },
      },
      // A2/Figma review 02/09 : libelle du seuil sous chaque competence
      seuilCertification : {
        "fr" : "Seuil de certification\u00a0: {seuil} %",
        "en" : "Certification threshold: {seuil}%",
      },
      // E1 review 02/09 : libelle du bouton d'export du Rapport d'impact
      exportImpact : {
        "fr" : "Rapport d'impact",
        "en" : "Impact report",
      },
      tutoTitle : {
        "fr" : "Comprendre progression",
        "en" : "Understanding progression",
      },
      tutoSubTitle : {
        "fr" : "La certification soft skills de votre diplôme",
        "en" : "The soft skills certification of your diploma",
      },
      graph : {
        title : {
          "fr" : "Résultats avant/après",
          "en" : "Results before/after",
        },
        subTitle : {
          "fr" : "Niveau de connaissance",
          "en" : "Level of knowledge",
        },
        before : {
          "fr" : "Avant",
          "en" : "Before",
        },
        after : {
          "fr" : "Après",
          "en" : "After",
        },
        legends : {
          "fr" : "Légendes\u00a0:",
          "en" : "Legends:",
        },
        expectedLevel : {
          "fr" : "Niveau attendu\u00a0:",
          "en" : "Expected Level:",
        },
        knowledgeBeforeLegend : {
          "fr" : "Connaissance avant",
          "en" : "Knowledge before",
        },
        knowledgeAfterLegend : {
          "fr" : "Connaissance après",
          "en" : "Knowledge after",
        },
        // D12 review 02/09 : bulles explicatives au survol des barres (textes
        // du Figma, traduits en francais comme demande)
        tooltipAvant : {
          "fr" : "Connaissance avant\u00a0: {score} %, parmi le {percentile}e percentile",
          "en" : "Knowledge before: {score}%, within the {percentile}th percentile",
        },
        // D10 review 02/09 : legende et bulle du repere de positionnement
        positionnement : {
          "fr" : "Positionnement",
          "en" : "Positioning",
        },
        // Texte fourni par Nawal (D12). Conserve volontairement : il servira
        // quand elle aura precise ce que trace le repere « Positionnement » du
        // Figma, retire a la relecture du 02/09 (il melangeait un rang et une
        // echelle de scores). Ne pas supprimer sans la consulter.
        tooltipPositionnement : {
          "fr" : "Niveau de positionnement\u00a0: {percentile}, niveau indiquant votre position par rapport aux autres participants",
          "en" : "Positioning level: {percentile}, indicating your position compared to the other participants",
        },
        /* D10, reponse d'Hicham du 03/09 : « Positionnement » est un PERCENTILE,
           donc un rang, pas un score. Il se lit sur une regle 0 a 100 fixe,
           independante de l'axe des scores, decoupee en trois zones. */
        positionnementZoneBas : {
          "fr" : "Les plus en difficulté",
          "en" : "Those struggling most",
        },
        positionnementZoneMoyenne : {
          "fr" : "Dans la moyenne",
          "en" : "Around average",
        },
        positionnementZoneHaut : {
          "fr" : "Les plus avancés",
          "en" : "The most advanced",
        },
        positionnementBulle : {
          "fr" : "{percentile}e percentile\u00a0: se situe mieux que {percentile} % de la promotion",
          "en" : "{percentile}th percentile: ahead of {percentile}% of the cohort",
        },
        /* P1 (fiche V3 de Nawal, 03/09) : les deux axes n'etaient pas lisibles
           par un non-specialiste. On nomme ce qu'ils portent, et une bulle
           explique COMMENT les lire — sans jargon. */
        axeY : {
          "fr" : "Niveau de performance",
          "en" : "Performance level",
        },
        axeYAide : {
          "fr" : "Cet axe indique le niveau atteint sur 100. Plus une barre est haute, plus le niveau de la tranche est élevé. Les deux barres se lisent ensemble\u00a0: celle de gauche au début du parcours, celle de droite à la fin.",
          "en" : "This axis shows the level reached out of 100. The higher the bar, the higher the level for that group. Read the two bars together: the left one at the start of the path, the right one at the end.",
        },
        axeX : {
          "fr" : "Tranches de la promotion, du niveau de départ le plus faible au plus élevé",
          "en" : "Cohort brackets, from the lowest starting level to the highest",
        },
        axeXAide : {
          "fr" : "Chaque colonne regroupe les étudiants selon leur rang de départ dans la promotion, exprimé en percentiles. « 50/84.9 » réunit ceux qui se situaient mieux que 50 à 85 % de leurs camarades au début du parcours. Ce découpage permet de voir si la progression touche autant les plus en difficulté que les plus avancés.",
          "en" : "Each column groups students by their starting rank within the cohort, in percentiles. « 50/84.9 » gathers those ahead of 50 to 85% of their peers at the start. This split shows whether progress reaches those struggling as much as the most advanced.",
        },
        tooltipApres : {
          "fr" : "Connaissance après\u00a0: {score} %, parmi le {percentile}e percentile",
          "en" : "Knowledge after: {score}%, within the {percentile}th percentile",
        },
        legendSubTitle : {
          "fr" : "Parmi --/-- percentile",
          "en" : "Among --/-- percentile",
        }
      },
    },
    blockModal : {
      topTitle : {
        "fr" : "Débloquez la fonctionnalité",
        "en" : "Upgrade to",
      },
      feature : {
        "fr" : "Fonctionnalité",
        "en" : "Feature",
      },
      subTitle : {
        mapping : {
          "fr" : "La progression soft skills de votre groupe",
          "en" : "The soft skills progression of your group",
        },
        certification : {
          "fr" : "La certification soft skills de votre diplôme",
          "en" : "The soft skills certification for your diploma",
        },
      },
      card1 : {
        mapping : {
          "fr" : "Découvrez les progrès des étudiants sur leurs connaissances en soft skills",
          "en" : "Discover students’ progress on their soft skills knowledge.",
        },
        certification : {
          "fr" : "Accédez à vos certifications soft skills par diplôme et par année.",
          "en" : "Access your soft skills certifications by degree and by year.",
        },
      },
      card2 : {
        mapping : {
          "fr" : "Cartographier les soft skills de vos étudiants par secteur et année d’études.",
          "en" : "Map your students' soft skills by sector and by the year of study.",
        },
        certification : {
          "fr" : "Retrouvez vos open badges par soft skills et par diplôme.",
          "en" : "Find your open badges with the help of the soft skills and degree.",
        },
      },
      button : {
        "fr" : "Contactez les commerciaux",
        "en" : "Contact Sales Team",
      },
    },
    drawerSearchEcoleMobile : {
      "fr" : "Choisir une école",
      "en" : "Select a school",
    },
    home : {
      "fr" : "Accueil",
      "en" : "Home",
    },
    monitoring : {
      "fr" : "Suivi",
      "en" : "Monitoring",
    },
    mapping : {
      "fr" : "Progression",
      "en" : "Progression",
    },
    certification : {
      "fr" : "Certification",
      "en" : "Certification",
    },
    homeWelcome : {
      "fr" : "Bonjour ",
      "en" : "Hello ",
    },
    homeWelcomeSub : {
      "fr" : "Bienvenue dans votre dashboard personnalisé.",
      "en" : "Welcome to your personalized dashboard.",
    },
    seeTuto : {
      "fr" : "Voir le tutoriel",
      "en" : "See the tutorial",
    },
    // E3 review 02/09 : recherche d'apprenant sur l'ecran Suivi
    rechercheApprenant : {
      "fr" : "Rechercher un apprenant…",
      "en" : "Search for a learner…",
    },
    noDataScreen : { // E2 review 02/09 : etat « donnees non disponibles » (Progression + Certification)
      title : {
        "fr" : "Données non disponibles",
        "en" : "Data not available",
      },
      subTitle : {
        "fr" : "Les résultats apparaîtront ici dès que les apprenants auront avancé dans le parcours.",
        "en" : "Results will appear here as soon as learners have progressed through the program.",
      },
      // Relecture finale 02/09 : ne pas dire « pas de données » quand c'est le
      // serveur qui n'a pas répondu. Les données existent, c'est le lien qui a
      // manqué : le message doit inviter à réessayer, pas laisser croire à un vide.
      titreReseau : {
        "fr" : "Connexion interrompue",
        "en" : "Connection lost",
      },
      sousTitreReseau : {
        "fr" : "Les résultats n'ont pas pu être chargés. Vérifiez votre connexion, puis rechargez la page.",
        "en" : "Results could not be loaded. Check your connection, then reload the page.",
      },
    },
  },
  mainLayout : {
    needHelp : {
      "fr" : "Besoin d'aide\u00a0?",
      "en" : "Need help?",
    },
    itsHere : {
      "fr" : "C'est ici",
      "en" : "It's here",
    },
    /* Pages de connexion : la cible du module n'y est pas connue, donc vous
       (regle du 07/10/2026, utils/formeAdresse.js). C'etait le seul texte au
       tu de ces pages. */
    languageTitle: {
      "fr" : "Choisissez votre langue",
      "en" : "Choose your language",
    },
    languageSubTitle: {
      "fr" : "Rising up est disponible dans 2 langues",
      "en" : "Rising up is available in 2 languages",
    },
    languageButtonContinue: {
      "fr" : "Continuer en Français",
      "en" : "Continue in English",
    }
  },
  forgotPasswordPage : {
    title : {
      "fr" : "Réinitialiser votre mot de passe",
      "en" : "Reset your password",
    },
    button : {
      "fr" : "Réinitialiser",
      "en" : "Reset",
    },
    afterText : {
      "fr" : "Si votre email existe, un email contenant un lien pour modifier votre mot de passe a été envoyé\u00a0!",
      "en" : "If your email address exists, an email containing a link to change your password has been sent.",
    }
  },
  resetPasswordPage : {
    title : {
      "fr" : "Modifier votre mot de passe",
      "en" : "Change your password",
    },
    button : {
      "fr" : "Modifier",
      "en" : "Change",
    },
    afterText : {
      "fr" : "Modification enregistrée\u00a0!",
      "en" : "Change saved!",
    }
  },
  registerPage : {
    pageTitle : {
      "fr" : "Inscription",
      "en" : "Register",
    },
    title : {
      "fr" : "Entrez le code groupe",
      "en" : "Enter group code",
    },
    codeField : {
      "fr" : "Code groupe",
      "en" : "Group code",
    },
    firstNameField : {
      "fr" : "Votre prénom",
      "en" : "Your firstname",
    },
    lastNameField : {
      "fr" : "Votre nom",
      "en" : "Your lastname",
    },
    ruTexte : {
      "fr" : "J'accepte les ",
      "en" : "I agree to the ",
    },
    ruTitle : {
      "fr" : "conditions générales d'utilisation",
      "en"  : "terms of use"
    },
    invalidCode : {
      "fr" : "Ce code n'existe pas",
      "en" : "This code does not exist",
    },
    alreadyUseEmail : {
      "fr" : "L'e-mail est déjà utilisé",
      "en" : "The email address is already in use",
    },
    confirmDialog : {
      title : {
        "fr" : "Vérifiez vos informations",
        "en" : "Check your information",
      },
      subTitle : {
        "fr" : "Tout changement ne sera plus possible dès lors que vous cliquez sur «\u00a0Continuer\u00a0»",
        "en" : "Any changes will no longer be possible once you click “Continue”",
      },
    },
  },
  loginPage : {
    title : {
      "fr" : "Connexion",
      "en" : "Login",
    },
    emailField : {
      "fr" : "Adresse email",
      "en" : "Email address",
    },
    passwordField : {
      "fr" : "Mot de passe",
      "en" : "Password",
    },
    forgotPassword : {
      "fr" : "Mot de passe oublié\u00a0?",
      "en" : "Forgotten password?",
    },
    eduServicesLogin : {
      "fr" : "Se connecter avec EduServices",
      "en" : "Login with EduServices",
    },
    button : {
      "fr" : "Se connecter",
      "en" : "Login",
    },
    noAccount : {
      "fr" : "Pas de compte\u00a0?",
      "en" : "No account?",
    },
    alreadyAccount : {
      "fr" : "Déjà un compte\u00a0?",
      "en" : "Already have an account?",
    },
    incorrectMessage : {
      "fr" : "Identifiants inconnus",
      "en" : "Unknown credentials",
    },
  }
}

const LanguageProvider = ({ children }) => {

  const [language, setLanguage] = useState(null)
  const [flag, setFlag] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [modalChangeLanguage, setModalChangeLanguage] = useState(false)

  const changeLanguage = (newLanguage) => {
    let findFlag = allLanguages.find((el) => el.id === newLanguage)
    setFlag(findFlag?.flag)
    setLanguage(newLanguage)
  }

  useEffect(() => {
    let detectLanguage = detectBrowserLanguage()
    let tmpLanguage = "en"
    if (detectLanguage.includes("fr-")) {
      tmpLanguage = "fr"
    }
    let findFlag = allLanguages.find((el) => el.id === tmpLanguage)
    setFlag(findFlag?.flag)
    setLanguage(tmpLanguage)
    setIsLoading(true)
  }, [])


  return (
    <LanguageContext.Provider
      value={{
        actLanguage : language,
        actLanguageFlag : flag,
        languageValues : values,
        changeLanguage,
        modalChangeLanguage,
        setModalChangeLanguage,
        allLanguages,
      }}
    >
      {children}
    </LanguageContext.Provider>
  )
}

export default LanguageContext

export { LanguageProvider }
